import React from 'react';
import {
    withStyles,
    Grid,
    ButtonBase,
    Typography,
    ListItem,
    Avatar,
    Divider,
} from '@material-ui/core';

const ICONS = [
    require('../../images/icons/icon_txl.png'),
    require('../../images/icons/icon_qunliao.png'),
    require('../../images/icons/icon_tjhy.png')
];

class ChatBookItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    _onListItemClick = () => {
        this.props.onClick && this.props.onClick();
    }

    render() {
        const { classes, data } = this.props;
        return (
            <ListItem disableRipple button onClick={() => this._onListItemClick()} className={classes.root}>
                <Grid container direction='row' alignItems='center' style={{ flex: 1 }}>
                    <Grid container direction='row' alignItems='center' justifyContent='space-between' style={{ flex: 1 }}>
                        <Grid container direction='row' style={{ flex: 1 }}>
                            <Avatar src={data.profile.avatar} className={classes.menuIcon} />
                            <Grid className={classes.content}>
                                <Typography style={{ color: '#0D0D0D', fontSize: 14, marginLeft: 10, fontWeight: 'bold' }}>{data.profile.nick}</Typography>
                                <Typography style={{ color: '#878787', fontSize: 10, marginLeft: 10 }}>{data.userID}</Typography>
                            </Grid>
                        </Grid>
                        <Grid style={{ flex: 1, maxWidth: 64 }}>
                            <ButtonBase className={classes.chatButton}>聊天</ButtonBase>
                        </Grid>
                    </Grid>
                    <Grid container direction='row' alignItems='center'>
                        <Divider className={classes.divider}></Divider>
                    </Grid>
                </Grid>
            </ListItem>
        );
    }
}
export default withStyles((theme) => ({
    root: {
        margin: 0,
        padding: 0,
    },
    menuIcon: {
        width: 40,
        height: 40,
    },
    content: {
        alignItems: 'flex-start',
        flex: 1,
    },
    divider: {
        backgroundColor: '#FAFAFA',
        height: 1,
        width: 'calc(100% - 54px)',
        marginLeft: 52,
        marginTop: 4
    },
    chatButton: {
        width: 64,
        height: 24,
        backgroundColor: '#2E2E2E',
        borderRadius: 12,
        color: '#FFF',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 13,
        marginRight: 8
    }

}))(ChatBookItem);
